// extracted by mini-css-extract-plugin
export default {"tab":"TabMenu_tab__IPr4D","tabPanel":"TabMenu_tabPanel__ccMlE"};